'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../../atoms/IconImg/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var ActionButton = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(ActionButton, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(ActionButton);

  function ActionButton() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, ActionButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleClick", function (event) {
      _this.props.onClick(event);
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(ActionButton, [{
    key: "buttonClasses",
    value: function buttonClasses() {
      var classes = ['ds-mol-option-picker-trigger'];
      if (this.props.title.length === 0) classes.push('empty');
      if (!this.props.arrow) classes.push('no-arrow');
      if (this.props.disabled) classes.push('disabled');
      if (this.props.className) classes.push(this.props.className);
      return classes.join(' ');
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement("button", {
        type: "button",
        className: this.buttonClasses(),
        onClick: this.handleClick
      }, this.props.children, this.props.icon && /*#__PURE__*/React__default['default'].createElement(index, {
        icon: this.props.icon
      }), this.props.title);
    }
  }]);

  return ActionButton;
}(React__default['default'].Component);

_rollupPluginBabelHelpers.defineProperty(ActionButton, "propTypes", {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  icon: PropTypes__default['default'].string,
  title: PropTypes__default['default'].string.isRequired,
  onClick: PropTypes__default['default'].func,
  arrow: PropTypes__default['default'].bool
});

_rollupPluginBabelHelpers.defineProperty(ActionButton, "defaultProps", {
  children: null,
  className: null,
  icon: null,
  disabled: false,
  arrow: false,
  onClick: function onClick() {}
});

module.exports = ActionButton;
